import { render, staticRenderFns } from "./pages2.vue?vue&type=template&id=a05ed342&"
import script from "./pages2.vue?vue&type=script&lang=js&"
export * from "./pages2.vue?vue&type=script&lang=js&"
import style0 from "./pages2.vue?vue&type=style&index=0&id=a05ed342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports